<div class="d-flex flex-column">
  <ng-container *ngFor="let t of ListSearch;">
    <div class="mb-3">
      <div class="d-flex flex-column flex-sm-row p-3" style="background-color: white;">
        <ngx-content-loading speed="3000ms" [width]="1000" style="width: 100%;" [height]="120"
          [primaryColor]="'#F5F5F5'" [secondaryColor]="'#d9d9d9'">
          <svg:g ngx-circle cy="50" cx="50" r="50" rx="5" ry="5"></svg:g>
          <svg:g ngx-rect width="400" height="20" y="0" x="150" rx="5" ry="5"></svg:g>
          <svg:g ngx-rect width="150" height="20" y="0" x="850" rx="5" ry="5"></svg:g>
          <svg:g ngx-rect width="500" height="20" y="30" x="150" rx="5" ry="5"></svg:g>
          <svg:g ngx-rect width="880" height="40" y="60" x="150" rx="5" ry="5"></svg:g>
        </ngx-content-loading>
      </div>
    </div>
  </ng-container>
</div>
